
import UMUM from "../../library/umum.js";

export default {
    data() {
        return {
            list_data: [],
            form: {
                nama_kegiatan: '',
                tanggal_mulai: '',
                tanggal_selesai: '',
                jam: '',
                lokasi: '',
                map_link: '',
                keterangan: '',
                file_name: null,
                jumlah_terdaftar: null,
                status: 1 // default aktif
            },
            fileBaru: null,
            UMUM: UMUM,
            btn_add: false,
            btn_edit: false,
            mdl_add: false,
            mdl_edit: false,
            mdl_delete: false,
            mdl_lihat: false,
            mdl_image: false,
            mdl_peserta: false,
            selectedImage: null,
            cari_value: "",
            page_first: 1,
            page_last: 1,
            page_limit: 9,
            total: 0,
            tipe: null,
            file_path: this.$store.state.url.URL_APP + "uploads/",
            statusOptions: [
                { label: '1 - Aktif', value: 1 },
                { label: '2 - Selesai', value: 2 },
                { label: '3 - Dibatalkan', value: 3 }
            ],
            currentJadwal: {},
            participants: [],
            participantsCount: {},
            pendonorDarahOptions: [],
            selectedPendonor: null,
            btn_add_peserta: false,
            searchInput: '',
        }
    },


    computed: {
        availableOptions() {
            // buat set id peserta (string) untuk perbandingan
            const partIds = new Set(
                (this.participants || [])
                    .map(p => String(p.pendonor_id ?? p.id ?? p.user_id ?? p.id_pendonor ?? ''))
                    .filter(Boolean)
            );

            // normalisasi pendonorDarahOptions -> pastikan id sebagai string dan ada label
            const normalized = (this.pendonorDarahOptions || []).map(opt => {
                return {
                    ...opt,
                    id: String(opt.id),
                    label: (opt.label || `${opt.nama_lengkap || opt.nama || '-'} / ${opt.golongan_darah || ''} ${opt.rhesus ? opt.rhesus : ''} / ${opt.no_hp || '-'}`).trim()
                };
            });

            // hilangkan yang sudah terdaftar
            let available = normalized.filter(o => !partIds.has(String(o.id)));

            // hapus duplikat berdasarkan id (keamanan)
            available = available.filter((item, idx, arr) => arr.findIndex(x => x.id === item.id) === idx);

            // support searchInput seperti sebelumnya
            const input = String(this.searchInput || '').toLowerCase().trim();
            if (!input) {
                return available.slice(0, 8);
            }
            return available.filter(opt => (opt.label || '').toLowerCase().includes(input));
        }
    },

    methods: {

        statusLabel(val) {
            if (val == 1) return 'Aktif'
            if (val == 2) return 'Selesai'
            if (val == 3) return 'Dibatalkan'
            return '-'
        },

        statusColor(val) {
            if (val == 1) return 'positive'
            if (val == 2) return 'warning'
            if (val == 3) return 'negative'
            return 'grey'
        },

        openEdit(data) {
            this.form = {
                id: data.id || null,
                nama_kegiatan: data.nama_kegiatan || '',
                tanggal_mulai: data.tanggal_mulai || '',
                tanggal_selesai: data.tanggal_selesai || '',
                jam: data.jam || '',
                lokasi: data.lokasi || '',
                map_link: data.map_link || '',
                keterangan: data.keterangan || '',
                file_name: data.file_name || null,
                jumlah_terdaftar: data.jumlah_terdaftar ?? null,
                status: data.status != null ? data.status : 1
            }
            this.fileBaru = null
            this.mdl_edit = true
        },


        openDelete(data) {
            this.form = { id: data.id }
            this.mdl_delete = true
        },

        openLihat(data) {
            this.form = {
                id: data.id || null,
                nama_kegiatan: data.nama_kegiatan || '',
                tanggal_mulai: data.tanggal_mulai || '',
                tanggal_selesai: data.tanggal_selesai || '',
                jam: data.jam || '',
                lokasi: data.lokasi || '',
                map_link: data.map_link || '',
                keterangan: data.keterangan || '',
                file_name: data.file_name || null,
                jumlah_terdaftar: data.jumlah_terdaftar ?? null,
                status: data.status != null ? Number(data.status) : 1
            }
            this.mdl_lihat = true
        },

        openImage(src) {
            this.selectedImage = src
            this.mdl_image = true
        },

        resetForm() {
            this.form = {
                id: null,
                nama_kegiatan: '',
                tanggal_mulai: '',
                tanggal_selesai: '',
                jam: '',
                lokasi: '',
                map_link: '',
                keterangan: '',
                file_name: null,
                jumlah_terdaftar: null,
                status: 1
            }
            this.fileBaru = null
        },

        async getView() {
            try {
                this.$store.commit("shoWLoading");

                const res = await fetch(this.$store.state.url.JADWAL_DONOR + "getview", {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        data_ke: this.page_first,
                        cari_value: this.cari_value,
                        page_limit: this.page_limit
                    })
                });

                const res_data = await res.json();

                this.list_data = res_data.data || [];
                this.total = res_data.total || 0;
                this.page_last = Math.ceil(this.total / this.page_limit) || 1;

                // update counts untuk semua jadwal yang ter-load (paralel)
                if (Array.isArray(this.list_data) && this.list_data.length) {
                    const promises = this.list_data.map(item => this.fetchParticipantsCount(item.id));
                    await Promise.all(promises);
                }

                this.$store.commit("hideLoading");
            } catch (err) {
                console.error("❌ Error getView Jadwal Donor:", err);
                this.$store.commit("hideLoading");
            }
        },

        addData() {
            this.btn_add = true;
            const formData = new FormData();

            formData.append("nama_kegiatan", this.form.nama_kegiatan);
            formData.append("tanggal_mulai", this.form.tanggal_mulai);
            formData.append("tanggal_selesai", this.form.tanggal_selesai);
            formData.append("jam", this.form.jam);
            formData.append("lokasi", this.form.lokasi);
            formData.append("map_link", this.form.map_link || '');
            formData.append("keterangan", this.form.keterangan || '');
            formData.append("jumlah_terdaftar", this.form.jumlah_terdaftar != null ? this.form.jumlah_terdaftar : '');
            // set status default = 1 (Aktif)
            formData.append("status", 1);

            // q-file v-model sudah di-bind ke form.file_name pada template Anda
            // jika user memilih file di add -> form.file_name akan menjadi File object
            if (this.form.file_name) {
                formData.append("file_name", this.form.file_name);
            }

            fetch(this.$store.state.url.JADWAL_DONOR + "addData", {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            })
                .then(res => res.json())
                .then(res_data => {
                    this.btn_add = false;
                    if (res_data.success) {
                        this.$q.notify({ type: "positive", message: res_data.message || "Sukses menambah jadwal" })
                        this.getView();
                        this.mdl_add = false;
                        this.resetForm();
                    } else {
                        this.$q.notify({ type: "negative", message: res_data.message || "Gagal menambah jadwal" })
                    }
                })
                .catch(err => {
                    this.btn_add = false;
                    console.error("❌ Error addData Jadwal Donor:", err);
                    this.$q.notify({ type: "negative", message: "Terjadi kesalahan server" })
                })
        },

        async updateData() {
            try {
                this.btn_edit = true;
                const formData = new FormData();
                formData.append("id", this.form.id);
                formData.append("nama_kegiatan", this.form.nama_kegiatan);
                formData.append("tanggal_mulai", this.form.tanggal_mulai);
                formData.append("tanggal_selesai", this.form.tanggal_selesai);
                formData.append("jam", this.form.jam);
                formData.append("lokasi", this.form.lokasi);
                formData.append("map_link", this.form.map_link || '');
                formData.append("keterangan", this.form.keterangan || '');
                formData.append("jumlah_terdaftar", this.form.jumlah_terdaftar != null ? this.form.jumlah_terdaftar : '');
                formData.append(
                    "status",
                    typeof this.form.status === "object"
                        ? this.form.status.value
                        : this.form.status
                );


                if (this.fileBaru) {
                    // user upload file baru pada edit
                    formData.append("file_name", this.fileBaru);
                } else {
                    // tidak upload baru -> kirim nama file lama agar backend tahu tetap memakai file lama
                    formData.append("file_name", this.form.file_name || '');
                }

                const res = await fetch(this.$store.state.url.JADWAL_DONOR + "editData", {
                    method: "POST",
                    headers: {
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: formData
                });

                const result = await res.json();
                this.btn_edit = false;
                if (result.success) {
                    this.$q.notify({ type: "positive", message: result.message || "Sukses update jadwal" })
                    this.mdl_edit = false;
                    this.getView();
                } else {
                    this.$q.notify({ type: "negative", message: result.message || "Gagal update jadwal" })
                }
            } catch (err) {
                this.btn_edit = false;
                console.error("❌ Error updateData Jadwal Donor:", err);
                this.$q.notify({ type: "negative", message: "Gagal update data" })
            }
        },

        removeData() {
            fetch(this.$store.state.url.JADWAL_DONOR + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id: this.form.id })
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({ type: "positive", message: res_data.message || 'Sukses menghapus jadwal' })
                        this.getView()
                    } else {
                        this.$q.notify({ type: "negative", message: res_data.message || 'Data tidak ditemukan' })
                    }
                })
                .catch(err => {
                    console.error("❌ Error removeData Jadwal Donor:", err);
                    this.$q.notify({ type: "negative", message: 'Terjadi kesalahan server' })
                })
        },

        cari_data() {
            this.page_first = 1;
            this.getView();
        },

        indexing(index) {
            return ((this.page_first - 1) * this.page_limit) + index;
        },

        async openPeserta(jadwal) {
            this.currentJadwal = jadwal || {};
            this.mdl_peserta = true;
            this.participants = [];
            this.pendonorDarahOptions = [];
            this.selectedPendonor = null;
            this.btn_add_peserta = false;
            this.searchInput = '';

            try {
                this.$store.commit("shoWLoading");

                // 1) ambil peserta (pendonor yang sudah ditautkan ke jadwal) dari backend
                const res = await fetch(this.$store.state.url.JADWAL_DONOR + "getParticipants", {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({ jadwal_id: this.currentJadwal.id })
                });
                const json = await res.json();
                this.participants = json.data || [];
                console.log('Participants updated:', this.participants);

                this.$set(this.participantsCount, this.currentJadwal.id, (this.participants || []).length);


                // 2) ambil seluruh pendonor dari tabel pendonor_darah untuk opsi select
                // GANTI endpoint di bawah jika nama endpoint Anda berbeda
                // contoh asumsi: this.$store.state.url.PENDONOR_DARAH + "list"
                const pendRes = await fetch(this.$store.state.url.REGIS_DONOR + "list", {
                    method: "GET",
                    headers: {
                        authorization: "kikensbatara " + localStorage.token
                    }
                });
                const pendJson = await pendRes.json();
                console.log('Raw backend data:', pendJson.data);
                // Cek duplikasi label
                const labels = pendJson.data.map(d => d.label);
                const uniqueLabels = [...new Set(labels)];
                if (labels.length !== uniqueLabels.length) {
                    console.warn('Duplikasi label dari backend:', labels.filter((l, i) => labels.indexOf(l) !== i));
                }


                console.log('pendonor list response:', pendJson);
                // pendJson.data diharapkan array objek: { id, nama, jenis_kelamin, golongan_darah, rhesus, no_hp }
                // Di dalam openPeserta(), ganti mapping ini:
                // this.pendonorDarahOptions = (pendJson.data || []).map(p => {
                //     const nama = p.nama_lengkap || '';  // <-- INI SALAH: p.nama_lengkap tidak ada
                //     const gol = p.golongan_darah || '';
                //     const rhesus = p.rhesus || '';
                //     const no_hp = p.no_hp || '';
                //     return {
                //         id: String(p.id),
                //         label: `${nama || '-'} — ${gol || '-'}${rhesus ? rhesus : ''} — ${no_hp || '-'}`,
                //         raw: p
                //     };
                // });
                // MENJADI: Gunakan data langsung dari backend (sudah ada label dan raw)
                // this.pendonorDarahOptions = pendJson.data || [];
                this.pendonorDarahOptions = (pendJson.data || []).map(p => {
                    return {
                        ...p,
                        id: String(p.id), // wajib string agar konsisten
                        label: p.label ? String(p.label) : `${p.nama_lengkap || p.nama || '-'} — ${p.golongan_darah || '-'} ${p.rhesus ? p.rhesus : ''} — ${p.no_hp || '-'}`.trim()
                    };
                });

                this.$store.commit("hideLoading");
            } catch (err) {
                console.error("❌ Error openPeserta:", err);
                this.$store.commit("hideLoading");
                this.$q.notify({ type: "negative", message: "Gagal memuat peserta / daftar pendonor" });
            }
        },

        onSelectPendonor(val) {
            console.log('selectedPendonor (objek penuh):', val);
            this.selectedPendonor = val;  // val adalah objek penuh

        },


        resetPesertaForm() {
            this.selectedPendonor = null;
            this.searchInput = '';
            this.btn_add_peserta = false;
        },

        async addPeserta() {
            if (!this.currentJadwal.id) {
                this.$q.notify({ type: "negative", message: "Data jadwal tidak ditemukan" });
                return;
            }
            if (!this.selectedPendonor) {
                this.$q.notify({ type: "negative", message: "Pilih pendonor dari daftar terlebih dahulu" });
                return;
            }

            this.btn_add_peserta = true;
            try {
                const body = {
                    jadwal_id: this.currentJadwal.id,
                    pendonor_id: this.selectedPendonor ? this.selectedPendonor.id : null  // Akses id dari objek
                };

                const res = await fetch(this.$store.state.url.JADWAL_DONOR + "addParticipant", {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(body)
                });

                const json = await res.json();
                this.btn_add_peserta = false;

                if (json.success) {
                    this.$q.notify({ type: "positive", message: json.message || "Peserta berhasil ditambahkan" });
                    await this.openPeserta(this.currentJadwal);
                    this.selectedPendonor = null;  // Reset
                } else {
                    this.$q.notify({ type: "negative", message: json.message || "Gagal menambahkan peserta" });
                }
            } catch (err) {
                this.btn_add_peserta = false;
                console.error("❌ Error addPeserta:", err);
                this.$q.notify({ type: "negative", message: "Terjadi kesalahan server" });
            }
        },

        removePeserta(pesertaId) {
            if (!pesertaId) {
                this.$q.notify({ type: 'negative', message: 'ID peserta tidak ditemukan' });
                return;
            }

            const ok = window.confirm('Apakah Anda yakin ingin menghapus peserta ini?');
            if (!ok) return;

            fetch(this.$store.state.url.JADWAL_DONOR + "removeParticipant", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id: pesertaId })
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({ type: "positive", message: res_data.message || 'Peserta berhasil dihapus' });
                        this.openPeserta(this.currentJadwal);
                    } else {
                        this.$q.notify({ type: "negative", message: res_data.message || 'Peserta tidak ditemukan' });
                    }
                })
                .catch(err => {
                    console.error("❌ Error removePeserta:", err);
                    this.$q.notify({ type: "negative", message: 'Terjadi kesalahan server' });
                });
        },
        onFilter(val, updateFn) {
            this.searchInput = val;  // Track input
            updateFn();  // Update opsi
        },
        async fetchParticipantsCount(jadwalId) {
            if (!jadwalId) return;
            try {
                const res = await fetch(this.$store.state.url.JADWAL_DONOR + "getParticipants", {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({ jadwal_id: jadwalId })
                });
                const json = await res.json();
                const count = Array.isArray(json.data) ? json.data.length : 0;
                // simpan ke map
                this.$set(this.participantsCount, jadwalId, count);
            } catch (err) {
                console.error("❌ Error fetchParticipantsCount:", err);
                this.$set(this.participantsCount, jadwalId, 0);
            }
        },


    },

    mounted() {
        this.getView();
    }
}
